import { render } from "./AccountsList.vue?vue&type=template&id=2d90715e&scoped=true"
import script from "./AccountsList.vue?vue&type=script&lang=js"
export * from "./AccountsList.vue?vue&type=script&lang=js"

import "./AccountsList.vue?vue&type=style&index=0&id=2d90715e&scoped=true&lang=postcss"

import exportComponent from "/codebuild/output/src2914688552/src/be-admin-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d90715e"]])

export default __exports__